module.exports = __webpack_public_path__ + "components/country-flag/static/do-7005d4713361e4964dc5040bf8e0e432.svg";